// import request from './axios-instance.js'
// import { equipmentMode } from './index.js'

// const equipment = {
//   //设备列表
//   equipmentList () {
//     return '9999999999'
//     // request({
//     //   url:'/equipment/list',
//     //   method:'get',
//     //   params,
//     //   hideloading:false
//     // })
//   },

//   //设备详情
//   equipmentDetail (eid,params) {
//     return request({
//       url:'',
//       method:'get',
//       params:{
//         eid
//       },
//       hideloading:true
//     })
//   },

// }

// const equipmentMode = {
//   equipmentList () {

//     var res = request({
//       url:'/equipment/list',
//       method:'get',
//       hideloading:false
//     })

//     return res;

//   }
// }
var equipmentMode = {}

equipmentMode.equipmentList = '/equipment/list';//获取设备列表
equipmentMode.equipmentAdd = '/equipment/add';//注册设备
equipmentMode.equipmentShip = '/equipment/ship';//设备出库
equipmentMode.equipmentUpdate = '/equipment/update';//修改设备
equipmentMode.equipmentCertainaccounts = '/equipment/certainaccounts';//获取可与设备关联的账号列表
equipmentMode.equipmentDelete = '/equipment/delete';//设备注销
equipmentMode.equipmentDetail = '/equipment/detail';//设备详情
equipmentMode.equipmentSurgery = '/equipment/surgery';//设备使用记录
equipmentMode.equipmentSurgeryDetail = '/equipment/surgery-detail';//设备出库
equipmentMode.equipmentTypeList = '/equipment/type/list';//获取所有设备类型
equipmentMode.equipmentTypeAdd = '/equipment/type/add';//添加设备类型
equipmentMode.equipmentTypeUpdate = '/equipment/type/update';//修改设备类型
equipmentMode.equipmentTypeDelete = '/equipment/type/delete';//删除设备类型


export {equipmentMode}




// WEBPACK FOOTER //
// ./src/api/equipment.js